import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["tab", "tabPanel"]

  initialize() {
    this.showTab()
  }

  change(e) {
    // Only prevent default if this is not a Turbo Frame link
    if (!e.target.dataset.turboFrame) {
      e.preventDefault()
    }
    this.index = this.tabTargets.indexOf(e.target)
    this.showTab(this.index)
  }

  showTab() {
    this.tabPanelTargets.forEach((el, i) => {
      if (i == this.index) {
        el.classList.remove('d-none')
      } else {
        el.classList.add('d-none')
      }
    })

    this.tabTargets.forEach((el, i) => {
      if (i == this.index) {
        el.classList.add('active')
      } else {
        el.classList.remove('active')
      }
    })
  }

  get index() {
    return parseInt(this.data.get('index'))
  }

  set index(value) {
    this.data.set("index", value)
    //this.showTab()
  }
}
